import React, { useContext } from 'react';
import { ICustomersContext, CustomersContext } from '../../../../customersState/customersContext';
import Text from 'components/Text/Text';
import Item from './components/Item';
import classNames from 'classnames';
import style from './ActiveCustomersList.module.scss';

export const ActiveCustomersList: React.FC = () => {
	const { customers } = useContext<ICustomersContext>(CustomersContext);

	const nameHeadingClasses = classNames(style.name, style.heading);
	const restaurantsHeadingClasses = classNames(style.restaurants, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="ActiveCustomersList">
			<div className={style.tableHeaders}>
				<Text
					className={nameHeadingClasses}
					translationNameSpace="listing"
					translationKey="nameLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={restaurantsHeadingClasses}
					translationNameSpace="listing"
					translationKey="restaurantsHotelsLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={actionHeadingClasses}
					translationNameSpace="listing"
					translationKey="actionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{customers.customers.map((item, index) => (
				<Item data={item} key={item.id} index={index} />
			))}
		</div>
	);
};
